import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pentera = defineConnector({
  identifier: "pentera",
  name: "Pentera",
  tagLine: "Automated security validation",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.pentera\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Pentera console and navigate to **Administration > API Access** to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your Pentera details",
      items: [
        {
          kind: "url",
          label: "Pentera server URL",
          required: true,
          placeholder: "https://yourcompany.pentera.io",
          target: { kind: "configuration", field: "baseUrl" },
          helperText: "Your Pentera console URL.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/api/v1/system/health`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    PENTERA_URL: baseUrl || "",
  }),
});
